// What a cell shows when it has nothing to show: a grey dash.
const EmptyCell = () => <span className="text-gray-400">-</span>;

export default EmptyCell;
